import * as React from 'react';
import Grid from '@mui/material/Grid2';
import { Box, Divider, InputAdornment, Typography } from '@mui/material';
import TextFieldComponent from '../../../components/form/TextFieldComponent';
import { formatPrice, roundToTwo } from '../../../utils/storageUtil';
interface TotalComponentProps {
  billableFormItems: any[];
  companyDetails: any;
  projectForm: any;
  viewOnly: boolean;
  overheads: number;
  overheadPercentage: any;
  handleOverHeads(num: number): void;
  handleOverHeadPercentage(num: number): void;
  projectPercentage: number;
  contigencyPercentage: number;
  projectMargin: number;
  handleProjectPercentage(num: number): void;
  handleContigencyPercentage(num: number): void;
  handleProjectMargin(num: number): void;
  GST: number;
  GSTPrice?: number;
}
const TotalComponent: React.FC<TotalComponentProps> = ({
  billableFormItems,
  companyDetails,
  projectForm,
  viewOnly,

  overheads,
  overheadPercentage,
  handleOverHeads,
  handleOverHeadPercentage,
  projectPercentage,
  contigencyPercentage,
  projectMargin,
  handleProjectPercentage,
  handleContigencyPercentage,
  handleProjectMargin,
  GST,
  GSTPrice,
}) => {
  const [resourceTotal, setResourceTotal] = React.useState({});
  const [overheadPercent, setOverheadPercent] = React.useState<any>(
    overheadPercentage ? overheadPercentage.toString() : overheadPercentage
  );

  const formatPercentDisplay = (val: any): string =>
    Number(parseFloat(val) || 0).toFixed(2);

  const [overheadInput, setOverheadInput] = React.useState<string>(() =>
    formatPercentDisplay(overheadPercentage)
  );
  const [contigencyInput, setContigencyInput] = React.useState<string>(() =>
    formatPercentDisplay(contigencyPercentage)
  );
  const [projectInput, setProjectInput] = React.useState<string>(() =>
    formatPercentDisplay(projectPercentage)
  );
  const [projectMarginInput, setProjectMarginInput] = React.useState<string>(
    () => formatPercentDisplay(projectMargin)
  );
  const [focusedField, setFocusedField] = React.useState<string | null>(null);

  React.useEffect(() => {
    if (focusedField !== 'overheadPercent') {
      setOverheadInput(formatPercentDisplay(overheadPercentage));
    }
  }, [overheadPercentage]);
  React.useEffect(() => {
    if (focusedField !== 'contigencyPercentageField') {
      setContigencyInput(formatPercentDisplay(contigencyPercentage));
    }
  }, [contigencyPercentage]);
  React.useEffect(() => {
    if (focusedField !== 'projectPercentageField') {
      setProjectInput(formatPercentDisplay(projectPercentage));
    }
  }, [projectPercentage]);
  React.useEffect(() => {
    if (focusedField !== 'projectMarginField') {
      setProjectMarginInput(formatPercentDisplay(projectMargin));
    }
  }, [projectMargin]);

  const handlePercentInputChange = (
    e: any,
    setLocal: (v: string) => void,
    parentHandler: (event: any) => void
  ) => {
    const v = e.target.value;
    if (v === '' || /^\d*\.?\d{0,2}$/.test(v)) {
      setLocal(v);
      parentHandler(e);
    }
  };
  const handlePercentBlur = (
    name: string,
    localValue: string,
    setLocal: (v: string) => void
  ) => {
    setFocusedField(null);
    setLocal(formatPercentDisplay(localValue));
  };
  React.useEffect(() => {
    if (billableFormItems.length > 0) {
      generateTotal(billableFormItems);
    } else {
      setResourceTotal(0.0);
    }
  }, [billableFormItems]);
  React.useEffect(() => {
    if (projectForm.cost && overheadPercent) {
      calculateIndirectCost(overheadPercent);
    }
  }, [projectForm.cost, overheadPercent]);

  // Recalculate Project Margin percentage whenever any Subtotal component changes
  React.useEffect(() => {
    if (projectMargin) {
      calculateProjectMarginPercentage(projectMargin);
    }
  }, [overheads, contigencyPercentage, projectForm.cost]);
  // React.useEffect(() => {
  //   if (companyDetails) {
  //     if (companyDetails.financial.length > 0) {
  //       setOverheadPercent(companyDetails.financial[0].overheadPercent);
  //     }
  //   }
  // }, [companyDetails]);
  const generateTotal = (itemsData: any) => {
    const totals = itemsData.reduce((acc: any, item: any) => {
      if (item.resources && item.resources.length > 0) {
        item.resources.forEach((detail: any) => {
          const price = roundToTwo(
            parseFloat(detail['items'][0]['price']) *
              parseInt(detail['items'][0]['quantity'])
          );
          const resourceType =
            typeof detail['resourceType'] === 'object'
              ? detail['resourceType']['name']
              : detail['resourceType'];
          if (!acc[resourceType]) {
            acc[resourceType] = 0;
          }
          acc[resourceType] += price;
        });
      }
      return acc;
    }, {});

    return setResourceTotal(totals);
  };
  const calculateIndirectCost = (percentageValue: any) => {
    handleOverHeads(getOverheadPercentageValue(percentageValue));
  };
  const getDirectCostPercentage = (value: any) => {
    if (value) {
      if (parseFloat(projectForm.cost) > 0) {
        const percentage =
          (parseFloat(value) * 100) /
          (projectForm.cost ? parseFloat(projectForm.cost) : 0);
        return roundToTwo(percentage).toFixed(2);
      } else {
        return '0.00';
      }
    } else {
      return '0.00';
    }
  };
  const handleInputChange = (e: any) => {
    const value = e.target.value.trim();
    const parsedValue = value === '' ? 0 : parseFloat(value);
    console.log(parsedValue, '-->>>>>>>');
    if (!isNaN(parsedValue)) {
      if (e.target.name === 'contigencyPercentageField') {
        const truncatedValue = roundToTwo(parsedValue);
        handleContigencyPercentage(truncatedValue);
        // Recalculate Project Margin percentage based on margin amount
        calculateProjectMarginPercentage(projectMargin);
      }
      if (e.target.name === 'projectPercentageField') {
        const truncatedValue = roundToTwo(parsedValue);
        handleProjectPercentage(truncatedValue);
        getProjectPercentageValue(truncatedValue);
      }
      if (e.target.name === 'projectMarginField') {
        handleProjectMargin(parsedValue);
        calculateProjectMarginPercentage(parsedValue);
      }
      if (e.target.name === 'overheadPercent') {
        const truncatedValue = roundToTwo(parsedValue);
        setOverheadPercent(truncatedValue);
        calculateIndirectCost(truncatedValue);
        handleOverHeadPercentage(truncatedValue);
        // Recalculate Project Margin percentage based on margin amount
        calculateProjectMarginPercentage(projectMargin);
      }
    }
  };
  const getSubtotal = () => {
    const directSubtotal = roundToTwo(
      parseFloat(projectForm.cost ? projectForm.cost : '0')
    );
    const indirectSubtotal = roundToTwo(
      (overheads ? overheads : 0) + getContigencyPercentageValue()
    );
    return roundToTwo(directSubtotal + indirectSubtotal);
  };
  const calculateProjectMarginPercentage = (projectPercentageTxt: any) => {
    const subTotal = getSubtotal();
    const percentage =
      ((projectPercentageTxt ? projectPercentageTxt : 0) * 100) / subTotal;
    handleProjectPercentage(percentage);
  };
  const getProjectPercentageValue = (projectPercentageTxt: any) => {
    const subTotal = getSubtotal();
    const percentage =
      ((projectPercentageTxt ? projectPercentageTxt : 0) * subTotal) / 100;
    handleProjectMargin(percentage);
    return roundToTwo(percentage);
  };
  const getContigencyPercentageValue = () => {
    const subTotal = parseFloat(projectForm.cost ? projectForm.cost : '0');
    const percentage =
      ((contigencyPercentage ? contigencyPercentage : 0) * subTotal) / 100;
    return percentage;
  };
  const getOverheadPercentageValue = (overheadPercentage: any) => {
    const subTotal = parseFloat(projectForm.cost ? projectForm.cost : '0');
    const percentage =
      ((overheadPercentage ? parseFloat(overheadPercentage) : 0) * subTotal) /
      100;
    return percentage;
  };
  const getSubmissionPrice = () => {
    const subTotal = getSubtotal();
    return subTotal + (projectMargin ? projectMargin : 0);
  };
  const getGST = () => {
    if (GSTPrice) return Number(GSTPrice);
    return (getSubmissionPrice() * GST) / 100;
  };
  return (
    <Box sx={{ padding: 4 }}>
      {/* Direct Costs */}
      <Box sx={{ marginBottom: 4 }}>
        <Typography variant="h6" fontWeight="bold" gutterBottom>
          Direct Cost
        </Typography>

        {Object.entries(resourceTotal).map(([key, value]: any) => (
          <Grid
            container
            spacing={2}
            key={key + '_tottla'}
            sx={{ marginBottom: 1 }}
          >
            <Grid size={6}>
              <Typography>{key}</Typography>
            </Grid>
            <Grid size={3} sx={{ textAlign: 'right' }}>
              <Typography>{getDirectCostPercentage(value)}%</Typography>
            </Grid>
            <Grid size={3} sx={{ textAlign: 'right' }}>
              <Typography>${roundToTwo(value).toFixed(2)}</Typography>
            </Grid>
          </Grid>
        ))}
        <Divider />
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            padding: '8px',
            backgroundColor: '#f5f5f5',
          }}
        >
          <Typography fontWeight="bold">Direct Subtotal</Typography>
          <Typography fontWeight="bold">
            ${roundToTwo(projectForm.cost ? projectForm.cost : 0).toFixed(2)}
          </Typography>
        </Box>
      </Box>

      {/* Indirect Costs */}
      <Box>
        <Typography variant="h6" fontWeight="bold" gutterBottom>
          Indirect Cost
        </Typography>

        <Grid
          container
          spacing={2}
          key={'indirectCost_grid'}
          sx={{ marginBottom: 1 }}
        >
          <Grid size={6}>
            <Typography>{'Overheads'}</Typography>
          </Grid>
          <Grid size={3} sx={{ textAlign: 'right' }}>
            {viewOnly === true && (
              <Typography>
                {roundToTwo(overheadPercentage).toFixed(2)}%
              </Typography>
            )}
            {viewOnly === false && (
              <TextFieldComponent
                label=""
                keyName="overheadPercent"
                name="overheadPercent"
                value={overheadInput}
                onChange={(e: any) =>
                  handlePercentInputChange(
                    e,
                    setOverheadInput,
                    handleInputChange
                  )
                }
                onFocus={() => setFocusedField('overheadPercent')}
                onBlur={() =>
                  handlePercentBlur(
                    'overheadPercent',
                    overheadInput,
                    setOverheadInput
                  )
                }
                errorStr={''}
                isRequired={false}
                type="text"
                boxStyle={{
                  width: '100px',
                  marginTop: '-5px',
                  marginLeft: 'auto',
                }}
                suffix={<InputAdornment position="end">%</InputAdornment>}
                style={{ width: '100px' }}
              />
            )}
          </Grid>
          <Grid size={3} sx={{ textAlign: 'right' }}>
            <Typography>${roundToTwo(overheads).toFixed(2)}</Typography>
          </Grid>
        </Grid>
        <Grid
          container
          spacing={2}
          key={'indirectCost_grid_contigencies'}
          sx={{ marginBottom: 1 }}
        >
          <Grid size={6}>
            <Typography>{'Contigencies'}</Typography>
          </Grid>
          <Grid size={3} sx={{ textAlign: 'right' }}>
            {viewOnly === false && (
              <TextFieldComponent
                label=""
                keyName="contigencyPercentageField"
                name="contigencyPercentageField"
                value={contigencyInput}
                onChange={(e: any) =>
                  handlePercentInputChange(
                    e,
                    setContigencyInput,
                    handleInputChange
                  )
                }
                onFocus={() => setFocusedField('contigencyPercentageField')}
                onBlur={() =>
                  handlePercentBlur(
                    'contigencyPercentageField',
                    contigencyInput,
                    setContigencyInput
                  )
                }
                errorStr={''}
                isRequired={false}
                type="text"
                boxStyle={{
                  width: '100px',
                  marginTop: '-5px',
                  marginLeft: 'auto',
                }}
                suffix={<InputAdornment position="end">%</InputAdornment>}
                style={{ width: '100px' }}
              />
            )}
            {viewOnly === true && (
              <Typography>
                {roundToTwo(contigencyPercentage).toFixed(2)}%
              </Typography>
            )}
          </Grid>
          <Grid size={3} sx={{ textAlign: 'right', mt: 2 }}>
            <Typography style={{ marginLeft: 'auto' }}>
              ${roundToTwo(getContigencyPercentageValue()).toFixed(2)}
            </Typography>
          </Grid>
        </Grid>

        <Divider />
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            padding: '8px',
            backgroundColor: '#f5f5f5',
          }}
        >
          <Typography fontWeight="bold">Indirect Subtotal</Typography>
          <Typography fontWeight="bold">
            $
            {roundToTwo(
              (overheads || 0) + getContigencyPercentageValue()
            ).toFixed(2)}
          </Typography>
        </Box>
        <Divider />
        <Box
          sx={{
            display: 'flex',
            marginTop: '20px',
            fontSize: '18px',
            justifyContent: 'space-between',
            padding: '8px',
            backgroundColor: '#f5f5f5',
          }}
        >
          <Typography fontWeight="bold" fontSize={'20px'}>
            Subtotal
          </Typography>
          <Typography fontWeight="bold" fontSize={'20px'}>
            ${getSubtotal().toFixed(2)}
          </Typography>
        </Box>

        <Grid
          container
          spacing={2}
          key={'projectPercentage'}
          sx={{ marginBottom: 1, marginTop: '20px', alignItems: 'center' }}
        >
          <Grid size={6}>
            <Typography>{'Project Margin'}</Typography>
          </Grid>
          <Grid size={3} sx={{ textAlign: 'right' }}>
            {viewOnly === false && (
              <TextFieldComponent
                label=""
                keyName="projectPercentageField"
                name="projectPercentageField"
                value={projectInput}
                onChange={(e: any) =>
                  handlePercentInputChange(
                    e,
                    setProjectInput,
                    handleInputChange
                  )
                }
                onFocus={() => setFocusedField('projectPercentageField')}
                onBlur={() =>
                  handlePercentBlur(
                    'projectPercentageField',
                    projectInput,
                    setProjectInput
                  )
                }
                errorStr={''}
                isRequired={false}
                type="text"
                boxStyle={{
                  width: '150px',
                  marginLeft: 'auto',
                  marginBottom: 0,
                }}
                suffix={<InputAdornment position="end">%</InputAdornment>}
                style={{ width: '150px' }}
              />
            )}
            {viewOnly && (
              <Typography>
                {roundToTwo(projectPercentage).toFixed(2)}%
              </Typography>
            )}
          </Grid>
          <Grid size={3} sx={{ textAlign: 'right' }}>
            {viewOnly === false && (
              <TextFieldComponent
                label=""
                keyName="projectMarginField"
                name="projectMarginField"
                value={projectMarginInput}
                onChange={(e: any) =>
                  handlePercentInputChange(
                    e,
                    setProjectMarginInput,
                    handleInputChange
                  )
                }
                onFocus={() => setFocusedField('projectMarginField')}
                onBlur={() =>
                  handlePercentBlur(
                    'projectMarginField',
                    projectMarginInput,
                    setProjectMarginInput
                  )
                }
                errorStr={''}
                isRequired={false}
                type="text"
                boxStyle={{
                  width: '150px',
                  marginLeft: 'auto',
                  marginBottom: 0,
                }}
                style={{ width: '150px' }}
                prefix={<InputAdornment position="start">$</InputAdornment>}
              />
            )}
            {viewOnly && (
              <Typography fontWeight="bold">
                ${formatPrice(projectMargin)}
              </Typography>
            )}
          </Grid>
        </Grid>

        <Grid
          container
          spacing={2}
          key={'projectPercentage_submissinprie'}
          sx={{ marginBottom: 1 }}
        >
          <Grid size={6}>
            <Typography marginTop={'20px'}>{''}</Typography>
          </Grid>
          {/* <Grid size={3} sx={{ textAlign: "right" }}>
             
            </Grid> */}
          <Grid
            size={6}
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Typography style={{ marginLeft: 'auto' }}>
              Submission Price
            </Typography>
            <Typography style={{ marginLeft: 'auto', fontWeight: 'bold' }}>
              ${roundToTwo(getSubmissionPrice()).toFixed(2)}
            </Typography>
          </Grid>
        </Grid>
        <Grid
          container
          spacing={2}
          key={'projectPercentage_gst_price'}
          sx={{ marginBottom: 1 }}
        >
          <Grid size={6}>
            <Typography marginTop={'20px'}>{''}</Typography>
          </Grid>
          {/* <Grid size={3} sx={{ textAlign: "right" }}>
             
            </Grid> */}
          <Grid
            size={6}
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Typography style={{ marginLeft: 'auto' }}>GST</Typography>
            <Typography style={{ marginLeft: 'auto', fontWeight: 'bold' }}>
              ${roundToTwo(getGST()).toFixed(2)}
            </Typography>
          </Grid>
        </Grid>
        <Divider />
        <Box
          sx={{
            display: 'flex',
            marginTop: '20px',
            fontSize: '18px',
            justifyContent: 'space-between',
            padding: '8px',
            backgroundColor: '#f5f5f5',
          }}
        >
          <Typography fontWeight="bold" fontSize={'20px'}>
            Price incl. GST
          </Typography>
          <Typography fontWeight="bold" fontSize={'20px'}>
            $
            {(roundToTwo(getSubmissionPrice()) + roundToTwo(getGST())).toFixed(
              2
            )}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};
export default TotalComponent;
